import { Pipe, PipeTransform } from '@angular/core';
import { NormalizeService } from 'app/services/common/normalize.service';

@Pipe({
    name: 'normalize'
})
export class NormalizePipe implements PipeTransform {
    constructor(private normalizeService: NormalizeService) {}

    transform(value: string): string {
        return this.normalizeService.normalize(value);
    }
}
